/**
 * @file components/biz/Status
 * @author dingyang
 */

import React from 'react';
import PropTypes from 'prop-types';

import {DU_PREFIX} from '../../_common/constants';

import {useLocale} from '../../locale';

import './index.less';

export interface StatusProps {
    type: string, // 状态类型【见DEFAULT_TYPE_CONFIG配置】
    text?: string // 状态对应文案
    style?: React.CSSProperties
}

const Status: React.FunctionComponent<StatusProps> = props => {
    const [locale] = useLocale('Status');
    // 状态对应默认配置项，支持后续拓展
    const DEFAULT_TYPE_CONFIG = {
        pending: {
            text: locale?.running
        },
        warning: {
            text: locale?.warning
        },
        success: {
            text: locale?.success
        },
        error: {
            text: locale?.error
        },
        unavailable: {
            text: locale?.unavailable
        }
    };
    const {type = 'success', text = DEFAULT_TYPE_CONFIG.success.text, style} = props;

    return (
        <div className={`${DU_PREFIX}-status`} style={style}>
            <div className={`${DU_PREFIX}-status-type ${DU_PREFIX}-status-type-${type}`}>
                {text}
            </div>
        </div>
    );
};

Status.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string,
    style: PropTypes.object
};

export default Status;
